export default function searchDirective(SearchService, MapService, utils) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "./components/search/search-template.html",
		scope: {
			open: "<?",
			types: "<?",
			placeholder: "@?",
			onResultSelect: "&?"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function ($element) {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				if (vm.open) {
					vm.activate();
				}
			};

			vm.activate = () => {
				vm.active = true;
			};

			vm.deactivate = () => {
				if (!vm.open) {
					vm.active = false;
				}
			};

			vm.onIconClick = () => {
				$element.find(".search__input").focus();
			};

			vm.clear = () => {
				vm.query = "";
				vm.execute();
			};

			vm.execute = utils.queue(() => {
				let query = vm.query || "";
				vm.hasValue = !!query;
				if (query.length >= 2) {
					SearchService.search(query, vm.types).then((orgs) => {
						if (query === vm.query) {
							let results = [],
								resultTypes = [],
								resultType = null,
								count = null;
							orgs.forEach((org) => {
								if (!resultType || resultType.type !== org.type) {
									resultType = {
										type: org.type,
										color: MapService.getColor(org.type)
									};
									resultTypes.push(resultType);
									count = 0;
								}

								count++;
								if (count <= 5) {
									let displayName = SearchService.markTerms(org.name, query);
									results.push(angular.extend({displayName, original: org}, org));
								}
							});
							vm.resultTypes = resultTypes;
							vm.results = results;
						}
					});
				} else {
					vm.resultTypes = null;
					vm.results = null;
				}
			});

			vm.keydown = (e) => {
				if (e.which === 13) {
					let current = vm.getCurrent();
					vm.select(current);
					e.preventDefault();
				} else if (e.which === 40 || e.which === 38) {
					vm.navigate(e.which === 40);
					e.preventDefault();
				} else {
					vm.execute();
				}
			};

			vm.navigate = (down) => {
				if (vm.results) {
					let current = vm.getCurrent(),
						currentIndex = vm.results.indexOf(current),
						next;
					if (currentIndex !== -1) {
						next = vm.results[currentIndex + (down ? 1 : -1)];
					} else {
						next = vm.results[down ? 0 : vm.results.length - 1];
					}
					vm.highlight(next);
				}
			};

			vm.highlight = (org) => {
				let current = vm.getCurrent();
				if (current) {
					current.active = false;
				}
				if (org) {
					org.active = true;
				}
			};

			vm.select = (org) => {
				if (org) {
					if (vm.onResultSelect) {
						vm.onResultSelect({result: org.original});
					} else {
						utils.goOrgState(org);
					}

					vm.clear();
				}
			};

			vm.getCurrent = () => (
				vm.results && vm.results.filter((org) => (org.active))[0]
			);
		}
	};
}
